import abhiConfig from './Aditya Birla Health Insurance Co. Limited.json';
import maConfig from './Medi Assist India TPA Pvt. Ltd..json';
import cmhtConfig from './CMHT.json';
import mpkayConfig from './MPKAY.json';
import abyConfig from './ABY.json';
import onMailPayerConfig from './On-Mail-Payer-Config.json';
import fhplConfig from './FHPL.json';
import rgiConfig from './Reliance General Insurance.json';
import hdfcConfig from './Hdfc Ergo General Insurance.json';
import vidalConfig from './Vidal.json';
import iciciConfig from './ICICI Lombard General Insurance.json';
import starConfig from './Star Health and Allied Insurance Co Ltd.json';
import paramountConfig from './Paramount Health Services & Insurance TPA Private Limited.json';
import bajajConfig from './Bajaj.json';
import careConfig from './Care.json';
import nivaBupaConfig from './Niva Bupa Health Insurance.json';
import cmsgiConfig from './Cholamandalam MS General Insurance.json';
import tataAig from './Tata Aig.json';
import rakshaConfig from './Raksha Health Insurance TPA Private Limited.json';
import medsaveConfig from './Medsave Health Insurance TPA Limited.json';
import heritageConfig from './Heritage Health Insurance TPA Private Limited.json';
import ycfhsConfig from './YCFHS.json';
import iciciIntegratedConfig from './ICICI.json';
import mdConfig from './MDINDIA.json';
import healthInsuranceTpaConfig from './Health Insurance TPA of India Limited.json';
import ksrtcSchemeConfig from './KSRTC.json';
import starIntegratedConfig from './Star_Integrated.json';
import universalSompoConfig from './USG.json';
import goDigitConfig from './GoDigit.json';
import healthIndiaTpaConfig from './Health India Insurance TPA Services Private Limited.json';
import voloConfig from './Volo.json';
import mchiConfig from './Manipal Cigna Health Insurance.json';
import iciciOrionConfig from './ICICI_Orion.json';

const formControlConfigs = {
  'Aditya Birla Health Insurance Co. Limited': abhiConfig,
  'Medi Assist Insurance TPA India Pvt Ltd': maConfig,
  'CMHT': cmhtConfig,
  'MPKAY': mpkayConfig,
  'ABY': abyConfig,
  'Family Health Plan Insurance TPA Limited': fhplConfig,
  'Reliance General Insurance': rgiConfig,
  'Reliance General Insurance Co. Ltd': rgiConfig,
  'On-mail-payers-config': onMailPayerConfig,
  'Vidal Health Insurance TPA Private Limited' : vidalConfig,
  'ICICI Lombard General Insurance' : iciciConfig,
  'HDFC ERGO General Insurance' : hdfcConfig,
  'Star Health and Allied Insurance Co Ltd' : starConfig,
  'Paramount Health Services & Insurance TPA Private Limited' : paramountConfig,
  'BAJAJ GENERAL INSURANCE LIMITED.' : bajajConfig,
  'Care Health Insurance': careConfig,
  'Niva Bupa Health Insurance': nivaBupaConfig,
  'Cholamandalam MS General Insurance': cmsgiConfig,
  'Tata AIG General Insurance': tataAig,
  'ABY-Fire': abyConfig,
  'Raksha Health Insurance TPA Private Limited': rakshaConfig,
  'ABY-Prison': abyConfig,
  'Medsave Health Insurance TPA Limited': medsaveConfig,
  'Yeshasvini': ycfhsConfig,
  'Heritage Health Insurance TPA Private Limited': heritageConfig,
  'ICICI Lombard GIC Ltd': iciciIntegratedConfig,
  'MDIndia Health Insurance TPA Pvt. Ltd.': mdConfig,
  'Health Insurance TPA of India Limited': healthInsuranceTpaConfig,
  'KSRTC': ksrtcSchemeConfig,
  'Star Health and Allied Insurance Co. Ltd. (SHAI)' : starIntegratedConfig,
  'Galaxy Health Insurance': maConfig,
  'Universal Sompo General Insurance Co. Ltd. (USGI)': universalSompoConfig,
  'Go Digit General Insurance': goDigitConfig,
  'Health India Insurance TPA Services Private Limited': healthIndiaTpaConfig,
  'Volo Health Insurance TPA Pvt Limited(East West)': voloConfig,
  'Yeshasvini_2025': ycfhsConfig,
  'ManipalCigna Health Insurance Company Limited': mchiConfig,
  'ICICI_Orion' : iciciOrionConfig,
};

export default formControlConfigs;
